import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import PropTypes from 'prop-types';

const InfoField = ({horizontal, reverse, align, title, titleProps, gridItemProps, children, ...rest}) => {
	return (
		<Grid container direction={horizontal ? 'column' : 'row'} {...rest}>
			<Grid item xs="4" {...gridItemProps}>
				<Typography variant="text" {...titleProps}>
					<Box component="span" fontWeight={reverse ? 'fontWeightBold' : ''} whiteSpace="nowrap">
						{title}
					</Box>
				</Typography>
			</Grid>
			<Grid item zeroMinWidth xs textAlign={align || 'left'}>
				<Typography variant="text">
					<Box component="span" fontWeight={reverse ? '' : 'fontWeightMedium'}>
						{children}
					</Box>
				</Typography>
			</Grid>
		</Grid>
	)
}

InfoField.propTypes = {
	horizontal: PropTypes.bool,
	align: PropTypes.string,
	reverse: PropTypes.bool, //reverse title and contents styles
	title: PropTypes.string,
	titleProps: PropTypes.object,
	gridItemProps: PropTypes.object,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired
}

export default InfoField;